import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import {IrbInitialSetupComponent} from "@irb/irb-initial-setup/irb-initial-setup.component";
import { CommonModule } from '@angular/common';
import {IrbCommonModule} from '@irb-common/irb-common.module';
import { DialogInitialSetupComponent } from './dialog-initial-setup/dialog-initial-setup.component';

@NgModule({
    imports: [
        RouterModule.forChild([{ path: 'initial-setup', component: IrbInitialSetupComponent}]),
        CommonModule,
        IrbCommonModule
    ],
    declarations: [IrbInitialSetupComponent, DialogInitialSetupComponent]
})
export class IrbInitialSetupModule { }
